const Categories = () => {
  const categories = [
    { id: 'adoption', name: 'Adoption', href: '/campaigns/adoption', icon: '👨‍👩‍👧' },
    { id: 'animalspets', name: 'Animals & Pets', href: '/campaigns/animal_pets', icon: '🐾' },
    { id: 'business', name: 'Business', href: '/campaigns/business', icon: '💼' },
    { id: 'community', name: 'Community', href: '/campaigns/community', icon: '🤝' },
    { id: 'church', name: 'Church', href: '/campaigns/church', icon: '⛪' },
    { id: 'viewall', name: 'View All', isSpecial: true, href: '/campaigns', icon: '→' },
    { id: 'competitive', name: 'Competitive', href: '/campaigns/competitive', icon: '🏆' },
    { id: 'creative', name: 'Creative', href: '/campaigns/creative', icon: '🎨' },
    { id: 'currentevents', name: 'Current Events', href: '/campaigns/current_events', icon: '📰' },
  ]

  return (
    <section className="py-16 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Header - Matching Figma */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Categories
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Browse campaigns by category
          </p>
        </div>
        
        {/* 3x3 Grid with one 2-column card - EXACT Figma layout */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
          
          {/* Row 1: 3 cards */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 lg:col-span-3">
            <CategoryCard category={categories[0]} />
            <CategoryCard category={categories[1]} />
            <CategoryCard category={categories[2]} />
          </div>
          
          {/* Row 2: 3 cards (left 2, right 1 tall) */}
          <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-6 lg:col-span-4">
            <div className="grid grid-cols-2 gap-6 sm:col-span-2 lg:col-span-2">
              <CategoryCard category={categories[3]} />
              <CategoryCard category={categories[4]} />
            </div>
            
            {/* View All - spans 2 columns and is taller */}
            <div className="sm:col-span-1 lg:col-span-2">
              <CategoryCard category={categories[5]} isLarge={true} />
            </div>
          </div>
          
          {/* Row 3: 3 cards */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 lg:col-span-3">
            <CategoryCard category={categories[6]} />
            <CategoryCard category={categories[7]} />
            <CategoryCard category={categories[8]} />
          </div>
          
        </div>
      </div>
    </section>
  )
}

// Separate component for category card
const CategoryCard = ({ category, isLarge = false }) => {
  return (
    <a
      href={category.href}
      className="block group"
    >
      <div className={`h-full rounded-xl p-6 border-2 transition-all duration-300 hover:shadow-lg ${
        category.isSpecial 
          ? 'border-green-500 bg-gradient-to-br from-green-500 to-blue-500 hover:border-green-600' 
          : 'border-gray-200 bg-white hover:border-green-400'
      } ${isLarge ? 'h-48 flex flex-col justify-center' : 'h-40'}`}>
        
        <div className="flex flex-col items-center justify-center h-full">
          {/* Icon */}
          <div className={`mb-4 ${
            category.isSpecial 
              ? 'text-white text-3xl' 
              : 'text-gray-600 text-2xl'
          }`}>
            {category.icon}
          </div>
          
          {/* Category Name */}
          <h3 className={`text-xl font-semibold text-center ${
            category.isSpecial ? 'text-white' : 'text-gray-800'
          }`}>
            {category.name}
          </h3>
          
          {/* Subtitle for View All */}
          {category.isSpecial && (
            <p className="text-white/90 text-sm mt-2 text-center">
              Browse all categories
            </p>
          )}
          
          {/* Hover indicator */}
          <div className={`mt-4 w-0 group-hover:w-10 h-1 rounded-full transition-all duration-300 ${
            category.isSpecial ? 'bg-white/70' : 'bg-green-400'
          }`}></div>
        </div>
      </div>
    </a>
  )
}

export default Categories